import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

const BaseDialog = ({ 
  open, 
  onClose, 
  title, 
  children, 
  actions,
  disableClose = false
}) => (
  <Dialog
    open={open}
    maxWidth="sm"
    fullWidth
    onClose={disableClose ? undefined : onClose}
  >
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>{children}</DialogContent>
    {actions && <DialogActions style={{ padding: '16px 24px' }}>{actions}</DialogActions>}
  </Dialog>
)

export const PrescriptionDownloadOptionsDialog = ({
  open,
  onClose,
  onDownloadOnly,
  onSendToPatient,
  isLoading
}) => {
  const actions = (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
      <Button
        onClick={onDownloadOnly}
        disabled={isLoading}
        variant="outlined"
        fullWidth
        size="large"
      >
        {isLoading ? 'Processing...' : 'Download Only'}
      </Button>
      <Button
        onClick={onSendToPatient}
        disabled={isLoading}
        variant="contained"
        color="primary"
        fullWidth
        size="large"
      >
        Send to Patient
      </Button>
      <Button
        onClick={onClose}
        disabled={isLoading}
        variant="text"
        fullWidth
      >
        Cancel
      </Button>
    </div>
  )

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title="Download Prescription PDF"
      disableClose={isLoading}
      actions={actions}
    >
      <p style={{ margin: '16px 0', fontSize: '16px', lineHeight: '1.5' }}>
        Choose how you want to download the prescription:
      </p>
    </BaseDialog>
  )
}

export const ConfirmSendToPatientDialog = ({
  open,
  onClose,
  onConfirm,
  isLoading
}) => {
  const actions = (
    <>
      <Button
        onClick={onClose}
        disabled={isLoading}
        variant="outlined"
      >
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        disabled={isLoading}
        variant="contained"
        color="primary"
      >
        {isLoading ? 'Processing...' : 'Send to Patient'}
      </Button>
    </>
  )

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title="Confirm Send to Patient"
      disableClose={isLoading}
      actions={actions}
    >
      <div>
        <p style={{ margin: '16px 0', fontSize: '16px', lineHeight: '1.5' }}>
          Sending this prescription to the patient will mark this session as completed.
        </p>
        <p style={{ margin: '16px 0', fontSize: '14px', color: '#666' }}>
          Are you sure you want to proceed?
        </p>
      </div>
    </BaseDialog>
  )
}